import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  line-height: 18.78px;
  text-align: left;
  color: ${({ theme }) => theme.black4};
`;

const Input = styled.input`
  max-width: 729.87px;
  max-height: 134.09px;
  border: 1px solid ${({ theme }) => theme.grey3};
  outline: none;
  font-size: 16px;
  font-weight: 300;
  line-height: 18.78px;
  text-align: left;
  padding: 15px 20px;
  color: #183b56;
  border-radius: 15px;
  width: 100%;

  &::placeholder {
    font-size: 16px;
    font-weight: 500;
    line-height: 18.78px;
    text-align: left;
    color: #959ead;
  }
`;

const TextInput = ({
  label,
  placeholder,
  handleChange,
  type,
  value,
  defaultValue,
  required,
  name,
}) => {
  return (
    <Container>
      <Label>
        {label} {required && <sup>*</sup>}
      </Label>
      <Input
        placeholder={placeholder}
        type={type}
        value={value}
        defaultValue={defaultValue}
        onChange={handleChange}
        required
        name={name}
      />
    </Container>
  );
};

export default TextInput;
